export const urlRegex = /https?:\/\/[^\s]+\n?/g;